module.exports = __webpack_public_path__ + "img/Apple_Pay.svg";